import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import KPSelectableListItem from '../../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableListItem';
import KPNumberSelector from '../../../BaseTemplate/SSPCustomComponentLibrary/KPNumberSelector/KPNumberSelector';
import './PropertyInfo.css';
import { postToController } from '../../../../actions/apiActions';

class PropertyInfo extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            buildingInfo: this.props.sales.buildingInfo ?? { bedrooms: 0, geysers: 0, securityEstate: false, armedResponse: false, burglarBars: false, electricFence: false },
            bedroomList: [],
            bedroomIndex: 0,
            geyserList: [],
            geyserIndex: 0,
        };

        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.getBedroomList = this.getBedroomList.bind(this);
        this.getGeyserList = this.getGeyserList.bind(this);
        this.handleChangeBedrooms = this.handleChangeBedrooms.bind(this);
        this.handleChangeGeysers = this.handleChangeGeysers.bind(this);
    }

    handleItemSelect(id: string, selected: boolean) {
        let name = id.slice(3);
        name = name.charAt(0).toLowerCase() + name.slice(1);
        this.setState({ buildingInfo: { ...this.state.buildingInfo, [name]: selected } });
    }

    handleNumberChange(newValue: number, name: string) {
        this.setState({ buildingInfo: { ...this.state.buildingInfo, [name]: newValue } });
    }

    async componentWillMount() {
        await this.getBedroomList();
        await this.getGeyserList();
    }

    async getBedroomList() {
        await postToController(this.props.dispatch, 'GetBedrooms', JSON.stringify({})).then(async (response) => {
            this.setState({ bedroomList: response });
            if (this.state.buildingInfo.bedrooms != 0) {
                response.forEach((item, index) => {
                    if (item.id === this.state.buildingInfo.bedrooms) {
                        this.setState({ bedroomIndex: index });
                    }
                })
            }
        });
    }

    async getGeyserList() {
        await postToController(this.props.dispatch, 'GetGeyserCounts', JSON.stringify({})).then(async (response) => {
            this.setState({ geyserList: response });
            if (this.state.buildingInfo.geysers != 0) {
                response.forEach((item, index) => {
                    if (item.id === this.state.buildingInfo.geysers) {
                        this.setState({ geyserIndex: index });
                    }
                })
            }
        });
    }

    async handleNextStep() {
        this.props.dispatchAction(setQuoteData({ buildingInfo: this.state.buildingInfo }));
        await this.props.dispatchAction(handleNextStep());
    }

    async handleChangeBedrooms(changeValue: number) {
        let newIndex = this.state.bedroomIndex + changeValue
        if (newIndex < 0) {
            newIndex = 0
        }
        if (newIndex > this.state.bedroomList.length - 1) {
            newIndex = this.state.bedroomList.length - 1
        }

        let saveValue = this.state.bedroomList[newIndex]

        this.setState({ buildingInfo: { ...this.state.buildingInfo, bedrooms: saveValue.id }, bedroomIndex: newIndex });
    }

    async handleChangeGeysers(changeValue: number) {
        let newIndex = this.state.geyserIndex + changeValue
        if (newIndex < 0) {
            newIndex = 0
        }
        if (newIndex > this.state.geyserList.length - 1) {
            newIndex = this.state.geyserList.length - 1
        }

        let saveValue = this.state.geyserList[newIndex]

        this.setState({ buildingInfo: { ...this.state.buildingInfo, geysers: saveValue.id }, geyserIndex: newIndex });
    }

    public render() {
        let bedrooms = <>{this.state.bedroomList.length > 0 &&
            <div className="row noma borderBottom">
                <div className="nopa ssp-inputtextarea-col-label col-8">
                    <p className="ssp-form-label ssp-opacity-1 text-left justify-content-center pt-12px">
                        <b>Bedrooms</b>
                    </p>
                </div>
                <div className="nopa propertyInfoSelector col-4">
                    <button className="incrementButton inputBorder numberRadiusLeft text-center" onClick={() => this.handleChangeBedrooms(-1)} disabled={this.state.bedroomIndex === 0}>-</button>
                    <p className="inputBorder numberSelectBackground text-center pt-4px">
                        <b>{this.state.bedroomList[this.state.bedroomIndex].description}</b>
                    </p>
                    <button className="incrementButton inputBorder numberRadiusRight text-center" onClick={() => this.handleChangeBedrooms(1)} disabled={this.state.bedroomIndex === this.state.bedroomList.length - 1}>+</button>
                </div>
            </div>
        }</>

        let geysers = <>{this.state.geyserList.length > 0 &&
            <div className="row noma borderBottom">
                <div className="nopa ssp-inputtextarea-col-label col-8">
                    <p className="ssp-form-label ssp-opacity-1 text-left justify-content-center pt-12px">
                        <b>Geysers</b>
                    </p>
                </div>
                <div className="nopa propertyInfoSelector col-4">
                    <button className="incrementButton inputBorder numberRadiusLeft text-center" onClick={() => this.handleChangeGeysers(-1)} disabled={this.state.geyserIndex === 0}>-</button>
                    <p className="inputBorder numberSelectBackground text-center pt-4px">
                        <b>{this.state.geyserList[this.state.geyserIndex].description}</b>
                    </p>
                    <button className="incrementButton inputBorder numberRadiusRight text-center" onClick={() => this.handleChangeGeysers(1)} disabled={this.state.geyserIndex === this.state.geyserList.length - 1}>+</button>
                </div>
            </div>
        }</>

        return (
            <div className="container">
                <div className="mt-4 text-center">
                    <p>Please tell us a bit more about the building?</p>
                </div>

                <div className="row mt-4">
                    <div className="col-md-6 offset-md-3">
                        <div className="ssp-selectable-list  ssp-selectable-list-autosize property-info text-left">
                            {bedrooms}
                            {geysers}
                            <KPSelectableListItem
                                id="chkSecurityEstate"
                                label="24-hour security complex/estate"
                                value="SecurityEstate"
                                selected={this.state.buildingInfo.securityEstate}
                                className="checkboxGroup"
                                handleSelect={this.handleItemSelect}
                            />
                            <KPSelectableListItem
                                id="chkArmedResponse"
                                label="Alarm linked to armed response"
                                value="ArmedResponse"
                                selected={this.state.buildingInfo.armedResponse}
                                className="checkboxGroup"
                                handleSelect={this.handleItemSelect}
                            />
                            <KPSelectableListItem
                                id="chkBurglarBars"
                                label="Burglar bars"
                                value="BurglarBars"
                                selected={this.state.buildingInfo.burglarBars}
                                className="checkboxGroup"
                                handleSelect={this.handleItemSelect}
                            />
                            <KPSelectableListItem
                                id="chkElectricFence"
                                label="Electric fence"
                                value="ElectricFence"
                                selected={this.state.buildingInfo.electricFence}
                                className="checkboxGroup"
                                handleSelect={this.handleItemSelect}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 justify-content-center">
                        <button type="button" className="btn btn-solid-red btnNavigate" onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyInfo);